export default function getErrorDetail(error) {
    var _a;
    const graphQLErrors = (_a = error === null || error === void 0 ? void 0 : error.graphQLErrors) !== null && _a !== void 0 ? _a : [];
    const codes = graphQLErrors
        .map(error => { var _a; return (_a = error === null || error === void 0 ? void 0 : error.extensions) === null || _a === void 0 ? void 0 : _a.code; })
        .filter(Boolean);
    const data = graphQLErrors
        .map(error => { var _a; return (_a = error === null || error === void 0 ? void 0 : error.extensions) === null || _a === void 0 ? void 0 : _a.data; })
        .filter(Boolean);
    return { codes, data };
}
//# sourceMappingURL=getErrorDetail.js.map